module.exports = __webpack_public_path__ + "images/email/social-youtube.png";